import { LogService } from './../../share/log/log.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthenticateService } from '../../share/authenticate/authenticate.service';
import { ActivatedRoute } from '@angular/router';
import { FormControl, Validators, FormBuilder } from '@angular/forms';
import { ValidationService } from '../../share/validation/validation.service';
import * as MSG from '../../share/msg/msg';
import { MsgService } from '../../share/msg/msg.service';
import { UtilService } from '../../share/util/util.service';
import { VERSION } from '../../../environments/version';
import { CardSigninService } from './card-signin.service';
import { ICardSignin } from './card-signin-if';
declare var $;
import { Subscription } from 'rxjs';
import { InputType } from './card-signin-enum';

@Component({
  selector: 'app-card-signin',
  templateUrl: './card-signin.component.html',
  styleUrls: ['./card-signin.component.scss']
})
export class CardSigninComponent implements OnInit, OnDestroy {
  VERSION = VERSION;
  // ラベル名
  labelPageTitle = 'カードサインイン';
  labelSigninId = 'ユーザー名';
  labelPassword = 'パスワード';
  labelFelicaId = 'smile9ID認証';
  // 各フォーム毎にプロパティを設定。
  // Validationを"Validators.XXX"で指定する。(検証についてはモデル駆動型フォームを採用)
  felicaId = new FormControl('', [
    Validators.required
  ]);
  /** クエリパラメータから取得したprefix。Cognito認証前に付与される */
  smile9IdPrefix = null;
  /** input type */
  felicaIdType = 'password';
  loadImgClass = 'load-img-sm';

  /** フォーカス対象をテンプレートのidで指定。配列順にフォーカス移動する。）*/
  focusSeqNoneMode = [];

  autoInput = {
    felicaId: null,
  };

  timeoutFocusInputFelicaId;

  subHttpClients = new Subscription();

  public readonly InputType = InputType;
  public inputType = InputType.None;

  constructor(
    public authServ: AuthenticateService,
    private logServ: LogService,
    private builder: FormBuilder,
    public validationServ: ValidationService,
    public utilServ: UtilService,
    public msgServ: MsgService,
    private route: ActivatedRoute,
    private ownServ: CardSigninService,
  ) { }

  private enableTimeoutFocusInputFelicaId() {
    this.timeoutFocusInputFelicaId = setTimeout(() => {
      $('#felicaId').focus();
      this.enableTimeoutFocusInputFelicaId();
    }, 2000);
  }

  ngOnInit() {
    this.utilServ.uUI.setTitleBar(this.labelPageTitle);
    this.enableTimeoutFocusInputFelicaId();
    this.loadDisplaySettings();

    // クエリパラメータ取得
    this.route.queryParams.subscribe(
      params => {
        if (params['pre']) {
          this.smile9IdPrefix = params['pre'] + '-';
        }
      }
    );
    this.getFocusInputFelica();
  }

  ngOnDestroy() {
    clearTimeout(this.timeoutFocusInputFelicaId);
    // Http通信を一括キャンセル
    this.subHttpClients.unsubscribe();
  }

  private getFocusInputFelica() {
    setTimeout(() => {
      $('#felicaId').focus();
    }, 1);
  }

  public getCurrentSeq(): string[] {
    let focusArray: string[];
    focusArray = this.focusSeqNoneMode;
    return focusArray;
  }

  public async clickSignin() {
    // クエリパラメータから取得したprefixを保持。APIへSmile9ID認証時に付与する。
    let prefix = '';
    if (this.smile9IdPrefix) {
      prefix = this.smile9IdPrefix;
    }
    const smile9IdWithPrefix = prefix + this.felicaId.value;

    if (this.validaitonBeforeSignin()) {
      this.logServ.sendSigninLogAsync('ng', null, smile9IdWithPrefix);
      return;
    }
    const query: ICardSignin.GetCognitoInfo = {
      felica_id: smile9IdWithPrefix,
    };
    this.authServ.isLoading = true;
    this.subHttpClients.add(this.ownServ.getCognitoInfo(query).subscribe(
      response => {
        this.authServ.isLoading = false;
        const cognitoInfo: ICardSignin.CognitoInfo = response;
        if (cognitoInfo.bear_name && cognitoInfo.shirokuma_code) {
          this.authServ.signIn(cognitoInfo.bear_name, cognitoInfo.shirokuma_code, smile9IdWithPrefix);
        } else {
          this.logServ.sendSigninLogAsync('ng', null, smile9IdWithPrefix);
          this.msgServ.warning(MSG.WARNING.UNAUTHORIZED_FELICA, '');
          this.getFocusInputFelica();
        }
      },
      error => {
        this.logServ.sendSigninLogAsync('ng', null, smile9IdWithPrefix);
        this.authServ.isLoading = false;
        this.getFocusInputFelica();
      }
    ));
  }

  /** フォーム値の検証。(サインイン時)
    * @return {boolean} return = true ならば、データ更新しない
  */
  private validaitonBeforeSignin(): boolean {
    this.validationServ.validationInvalid = false;

    this.felicaId.markAsDirty();
    this.validationServ.formValidation(this.felicaId, this.labelFelicaId);

    return this.validationServ.validationInvalid;
  }

  private renderPrefix(): void {
    this.msgServ.info(`smile9IdPrefix: ${this.smile9IdPrefix === null ? this.smile9IdPrefix : this.smile9IdPrefix.slice(0, -1)}`, '', 0);
  }

  /** ソフトウェアキーボードが出てこないように制御する*/
  removeSoftwareKeyboard() {
    $('#felicaId').attr('inputmode','none');
  }

  /** inputmodeがnoneのままフォーカスを外すとカーソルが出現しないので、blur時にinputmodeをurlに戻す*/
  changeInputMode() {
    $('#felicaId').attr('inputmode','url');
  }

  clickCalcButton(number: number) {
    this.removeSoftwareKeyboard();
    const inputElement = (<HTMLInputElement>document.getElementById('felicaId'));
    inputElement.focus();

    let numString = String(this.felicaId.value);
    numString += number
    // 1文字目入力時に「null」が前に入ってしまうので削除
    let eraseNullNumStr = numString.replace("null","");

    if (eraseNullNumStr.match(/[0-9]/g)) {
      this.felicaId.setValue(eraseNullNumStr);
    } else {
      this.felicaId.reset(number);
    }
  }

  clearFelicaId() {
    this.felicaId.reset();
    $('#felicaId').focus();
  }

  oneClearFelicaId() {
    this.removeSoftwareKeyboard();
    const inputElement = (<HTMLInputElement>document.getElementById('felicaId'));

    let numString = inputElement.value.slice(0, -1);
    this.felicaId.setValue(numString);
    inputElement.focus();
  }

  public changeInputType(inputType: InputType): void {
    this.inputType = inputType;
    localStorage.setItem('[CardSignin]inputType', String(this.inputType));
  }

  private loadDisplaySettings(): void {
    const inputType = localStorage.getItem('[CardSignin]inputType');

    if (inputType) {
      this.inputType = Number(inputType);
    } else {
      localStorage.setItem('[CardSignin]inputType', String(InputType.InputForm));
      this.inputType = InputType.InputForm;
    }
  }
}
